<div class="new-diversion">
    <rt-new-diversion [tripIds]="[tripId]" (diversionCreated)="onDiversionCreated()">
    </rt-new-diversion>
</div>

<div *ngIf="tripId">
    <rt-diversion-list [tripId]="getCurrentTripId() | async"></rt-diversion-list>
</div>
